/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react'
import type { SVGProps } from 'react'
/**
 * @internal
 */
const SvgCall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
    clipRule="evenodd"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M2.001 3.021a1 1 0 0 1 1.242-.991l3.127.782a2.5 2.5 0 0 1 1.819 1.819l.576 2.303a2.5 2.5 0 0 1-.658 2.374l-1.961 1.961a17.1 17.1 0 0 0 6.586 6.585l1.961-1.961a2.5 2.5 0 0 1 2.374-.657l2.303.576a2.5 2.5 0 0 1 1.819 1.819l.777 3.108A1 1 0 0 1 21.001 22c-10.479 0-18.989-8.502-19-18.979"
      style={{
        fill: '#383838',
      }}
    />
  </svg>
)
export default SvgCall
